import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import GlobalBehavior from "../GlobalBehavior";

const colors = {
  primary: "#F02A4C",
  secondary: "#84a4fc",
};

export const Button = ({ solid, children, primary, ...props }) => {
  const primaryColor = primary ? colors.primary : colors.secondary;
  const textColor = solid ? "#FFF" : primaryColor;
  const bgColor = solid ? primaryColor : "transparent";

  return (
    <StyledButton
      textColor={textColor}
      bgColor={bgColor}
      solid={solid}
      {...props}
    >
      {children}
    </StyledButton>
  );
};

const StyledButton = styled.button`
  cursor: pointer;
  border-radius: 100vh;
  padding: 0.5rem;
  min-width: 10rem;
  ${GlobalBehavior.clickable}
  color: ${({ textColor }) => textColor};
  background-color: ${({ bgColor }) => bgColor};
  border-color: ${({ solid, textColor, bgColor }) =>
    solid ? bgColor : textColor};
  border-style: solid;
`;

Button.propTypes = {
  solid: PropTypes.bool,
  primary: PropTypes.bool,
  borderRadius: PropTypes.string,
  label: PropTypes.string,
  onClick: PropTypes.func,
  style: PropTypes.object,
};

Button.defaultProps = {
  solid: true,
  primary: true,
};
